import {
	Button, Card, Icon, Link, Stack, Text,
} from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { MdArrowForward } from 'react-icons/md';

import { getRoute } from '@/constants';

type JobApplicationForm = {
	companyName: string
	jobTitle:    string

	handleApplyJob: () => void
};

export const JobApplicationForm = ({ companyName, handleApplyJob, jobTitle }: JobApplicationForm) => {
	const t = useTranslations('jobs.application.form');

	return (
		<Stack gap="md">
			<Stack alignItems="center" textAlign="center">
				<Text color="primary.120" textStyle="h3">
					{t('title')}
				</Text>
				<Text>
					{t('description')}
				</Text>
			</Stack>
			<Card.Root>
				<Card.Body p={4}>
					<Card.Title mb={2}>
						{t('fields.companyName.label')}
					</Card.Title>
					<Text color="gray.100">
						{companyName}
					</Text>
				</Card.Body>
			</Card.Root>
			<Card.Root mb={6}>
				<Card.Body p={4}>
					<Card.Title mb={2}>
						{t('fields.jobTitle.label')}
					</Card.Title>
					<Text color="gray.100">
						{jobTitle}
					</Text>
				</Card.Body>
			</Card.Root>
			<Stack gap={4} mb={3}>
				<Text textAlign="center">
					{t('messages.helperText')}
				</Text>
				<Button onClick={handleApplyJob}>
					{t('actions.submit')}
				</Button>
			</Stack>
			<Link color="primary.100" href={getRoute.profile.index()} mx="auto">
				{t('actions.viewProfile')}
				<Icon as={MdArrowForward} />
			</Link>
		</Stack>
	);
};
